import { render, staticRenderFns } from "./ReportingComparison.vue?vue&type=template&id=63ff89b0&scoped=true"
import script from "./ReportingComparison.vue?vue&type=script&lang=js"
export * from "./ReportingComparison.vue?vue&type=script&lang=js"
import style0 from "./ReportingComparison.vue?vue&type=style&index=0&id=63ff89b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff89b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ff89b0')) {
      api.createRecord('63ff89b0', component.options)
    } else {
      api.reload('63ff89b0', component.options)
    }
    module.hot.accept("./ReportingComparison.vue?vue&type=template&id=63ff89b0&scoped=true", function () {
      api.rerender('63ff89b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingComparison.vue"
export default component.exports